export default __webpack_public_path__ + "locales/sr-Latn-RS/InfoPanel.json?hash=32cc2c0da51f1214fe283c802bdf6cd0";